export { default as getUrl } from './getUrl';
export { default as colorLegible } from './colorLegible';
export { default as hexToRGBa } from './hexToRGBa';
export { default as isIE } from './isIE';
export { default as isIOS } from './isIOS';
export { default as getParents } from './getParents';
export { fmt, deformatPercentage } from './fmtUtils';
export { default as parseaFechaHora } from './parseaFechaHora';
export { default as getIdHistorico } from './getIdHistorico';
export { default as addDot } from './addDot';
export { default as addStr } from './addStr';
export { getDepartamento, getDept } from './getDepartamento';
export { default as pushAmbitosNoCelebrados } from './pushAmbitosNoCelebrados';
export { default as tooltipMapa } from './tooltipMapa';
export { default as pSBC } from './changeColor';
export { default as getColoresMapaCalor } from './getColoresMapaCalor';

